export const ERROR_NAVIGATOR_COPY = {
  attention: (singular: boolean) =>
    singular ? 'question needs your attention' : 'questions need your attention',
  viewQuestion: 'View question',
  resolved: 'All errors have been resolved!',
  thereIsMore: '...and there are more',
  submitSurvey: 'Submit survey',
};
